
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/signin-organization",
      function () {
        return require("private-next-pages/authentication/signin-organization/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/signin-organization"])
      });
    }
  